
<i
class="material-icons-outlined close-icon"
style="color: #00233A"
(click)="onCancel()"
>close
</i>
<div class="schedulerLoading"  *ngIf="areFiltersLoading">
  <section>
    <div  class="pulsing">
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing">  {{ "Loading" | translate }}...</p>
  </section>
</div>


<div class="row tooltipTemplateContainer"  *ngIf="!areFiltersLoading">
  
   
 
  <div class="row">
    <h1 class="col-lg-12 dialog-title">
      <strong>{{"dateAppointment"| translate}}</strong>
    </h1>
  </div>
<div class="asideContainer">  
  <div class="row ">
    <p class="col-lg-7">
      
      <strong>{{"type" | translate}}:</strong> {{ hoveredData.Services[0].ServiceName}}
    </p>
    <p class="col-lg-5">
      <strong>{{"Brand" | translate}}:</strong> {{ hoveredData.MakeName
        }}
    </p>
  </div>
  <div class="row ">
    <p class="col-lg-7">
      <strong>{{"Time"| translate}}:</strong> {{ hoveredData.hour}}
    </p>
    <p class="col-lg-5">
      <strong>{{ "Client" | translate }}:</strong>  {{ hoveredData.CustomerName
      }}
    </p>
  </div>
  <div class="row ">
    <p class="col-lg-7">
      <strong>{{ "Plate" | translate }}:</strong> {{ hoveredData.LicenseNo }}
    </p>
    <p class="col-lg-5">
     
    </p>
  </div>
  
  <!-- <div class="row "  >
    <p class="col-lg-5" style="color: #19BEE7; top:0.5rem">
      <strong>Asistencia a la cita</strong>
    </p>
    <div class="col-lg-7 modifiersContainerpopuop d-flex justify-content-start" > 
      <button class="state-modifier-false" (click)="onStateChange(2)">
          {{ "CheckIn" | translate }}
      </button>
      <button class="state-modifier-false" (click)="onStateChange(3)">
          {{ "NotAssisted" | translate }}
      </button>
      
    </div>
   
  </div> -->

</div>


<div class="modify-buttons-advisor">

<button (click)="cancelAppointment()" class="cancel-button">
  <span>{{ "CancelAppointment" | translate }}</span>
</button>

<button (click)="rescheduleAppointment()" class="edit-button">
  <span>{{ "UpdateSchedule" | translate }}</span>
</button>
</div>
